module.exports = __webpack_public_path__ + "static/third-c57974d43b145ad7b2a13af478b88cee.svg";